export default __webpack_public_path__ + "static/media/1_4_hl.bb5c10c1.png";